export class MenuItemDefinition<TContext = any> {
  constructor(
    readonly header: string,
    readonly commandId: string,
    readonly icon?: string,
    readonly disableItem?: (context: TContext) => boolean,
    readonly contextId?: string,
    readonly isEdit?: boolean
  ) {}
}
